import * as moment from 'moment';

import { LANGUAGE_FORMAT_MAP } from '@sitegen/common/localization';

export const formatHours = (timeMoment: moment.Moment): string => {
    const locale = standardizeLocale(timeMoment.locale());
    const timeFormat = LANGUAGE_FORMAT_MAP[locale].time;

    return timeMoment.format(timeFormat);
};

export const localizeDate = (timeMoment: moment.Moment): string => {
    const locale = standardizeLocale(timeMoment.locale());
    const dateFormat = LANGUAGE_FORMAT_MAP[locale].date;

    return timeMoment.format(dateFormat);
};

/**
 * The function formats a month depending on the format settings specified for a locale. For example, given the date
 * '01/01/2019' and 'ru-RU' locale and 'MMMM' format, the return value is either 'январь' (the base form of the word)
 * or 'января' (the declined form of the word) depending on the declension flag in the settings.
 * @param timeMoment - a moment.js object
 */
export const localizeMonth = (timeMoment: moment.Moment): string => {
    const locale = standardizeLocale(timeMoment.locale());
    const { isMonthDeclensionNeeded, month } = LANGUAGE_FORMAT_MAP[locale];

    if (isMonthDeclensionNeeded) {
        return timeMoment.format(`D ${month}`).split(' ')[1];
    }

    return timeMoment.format(month);
};

export function standardizeLocale(locale: string): string {
    let [prefix, suffix = ''] = locale.split('-');
    suffix = suffix ? `-${suffix.toUpperCase()}` : '';

    return `${prefix}${suffix}`;
}

export function isLocaleValid(locale: string) {
    return RegExp(/[a-z]{2}[-]{1}([a-z]{2}|[A-Z]{2})$/g).test(locale);
}
